<template>
  <div class="min-h-screen font-sans bg-brand-bg text-brand-dark">
    <Header />
    <main
      class="container flex flex-col gap-12 px-4 py-8 mx-auto md:py-16 md:gap-24"
    >
      <!-- 步骤一 -->
      <section>
        <h2 class="mb-4 text-xl font-semibold text-gray-800">
          Step 1: Click "Returns & Orders" in Account & Lists Page:
        </h2>

        <!-- 
        图片占位符:
        请将下面的 <div> 替换为您自己的 <img> 标签。
      -->
        <div
          class="flex justify-center items-center w-full rounded-lg border-2 border-gray-300 border-dashed aspect-video"
        >
          <img class="min-h-40" :src="step1Png" alt="Step 1 Screenshot" />
        </div>
      </section>

      <!-- 步骤二 -->
      <section>
        <h2 class="mb-4 text-xl font-semibold text-gray-800">
          Step 2: Click “Order details” on the right order:
        </h2>

        <!-- 
        图片占位符:
        请将下面的 <div> 替换为您自己的 <img> 标签。
      -->
        <div
          class="flex justify-center items-center w-full rounded-lg border-2 border-gray-300 border-dashed aspect-video"
        >
          <img :src="step2Png" alt="Step 2 Screenshot" />
        </div>
      </section>
    </main>
    <Footer />
  </div>
</template>

<script>
import Header from "@/components/header";
import Footer from "@/components/footer";
import step1Png from "@/assets/step1.webp";
import step2Png from "@/assets/step2.webp";
export default {
  name: "OrderStepsContent",
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      step1Png,
      step2Png,
    };
  },
  // 这个纯展示组件不需要任何 script 逻辑
};
</script>

<!-- 注意: 此处没有 <style> 模块，所有样式均由 Tailwind CSS 类名提供 -->
